// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"67dda931","330":"e810b651","350":"9804a558","843":"d302e1c8","977":"29c13c82"}[chunkId] + ".chunk.js";
};